// extracted by mini-css-extract-plugin
export var container = "_e9-0";
export var content = "_e9-3";
export var customerTitle = "_e9-4";
export var empty = "_e9-5";
export var gray = "_e9-6";
export var header = "_e9-7";
export var info = "_e9-8";
export var loading = "_e9-2";
export var loadingCard = "_e9-9";
export var oneLine = "_e9-a";
export var personName = "_e9-e";
export var pillContainer = "_e9-b";
export var selected = "_e9-1";
export var text = "_e9-c";
export var twoLines = "_e9-d";
export var unread = "_e9-f";
export var unreadIndicator = "_e9-g";